import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createMyCompany,
  deleteMyCompany,
  getMyCompanies,
  removeMyCompanyPennylaneKey,
  saveMyCompanyPennylaneKey,
  updateMyCompany,
} from '../services/api.js'

const KEY = ['myCompanies']

/** Compte > Entreprises : sociétés « Prestataire » et leur clé Pennylane (organisation, ou utilisateur seul). */
export function useMyCompanies() {
  const queryClient = useQueryClient()
  const onSuccess = () => queryClient.invalidateQueries({ queryKey: KEY })
  const query = useQuery({ queryKey: KEY, queryFn: getMyCompanies })

  return {
    ...query,
    companies: query.data?.companies ?? [],
    create: useMutation({ mutationFn: createMyCompany, onSuccess }),
    update: useMutation({ mutationFn: updateMyCompany, onSuccess }),
    remove: useMutation({ mutationFn: deleteMyCompany, onSuccess }),
    savePennylane: useMutation({ mutationFn: saveMyCompanyPennylaneKey, onSuccess }),
    removePennylane: useMutation({ mutationFn: removeMyCompanyPennylaneKey, onSuccess }),
  }
}
